var debugProps = [
    "config",
    "headers",
    "request",
    "statusText"
];
var isDebug = false; // Switch to True to store request details into header, False to ignore

class ResponseDataExtractor {
    constructor(response){
        this.response = response;
    }
    get data(){
        while(this.response && this.response.data){
            var newData = {};
            if(typeof this.response.data == "string"){
                this.response.payload = this.response.data
            }
            else if(Array.isArray(this.response.data)){
                newData.list = this.response.data;
            }else{
                newData = { ...this.response.data };
            }

            for(var key in this.response){
                // if(key != "data" || (!isDebug && !debugProps.includes(key))){
                if(key != "data"){
                    newData[key] = this.response[key]
                }
            }
            this.response = newData;
        }
        return this.response
    }
}

module.exports = ResponseDataExtractor;